export default __webpack_public_path__ + "static/media/lobby_fourth_image.6cb71778.jpg";